export default __webpack_public_path__ + "static/media/product-promotions.dd697256.svg";